"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabComponent = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
/**
 * Tab component used to switch between content panels
 *
 */
const TabComponent = (_a) => {
    var { selectedTab, tabs } = _a, rest = __rest(_a, ["selectedTab", "tabs"]);
    return (react_1.default.createElement(styled_1.Wrapper, null,
        react_1.default.createElement(styled_1.TabsWrapper, { count: tabs.length, className: "mlt-tablist" }, tabs.map(({ label, action }, index) => (react_1.default.createElement(styled_1.Tab, Object.assign({ key: `tab-${label}`, onClick: action, className: `mlt-tab ${(selectedTab === index) ? 'selected' : ''}`, count: tabs.length }, rest), label)))),
        react_1.default.createElement(styled_1.SliderBar, null,
            react_1.default.createElement(styled_1.SelectionBar, { selectedTab: selectedTab, count: tabs.length }))));
};
exports.TabComponent = TabComponent;
exports.default = exports.TabComponent;
//# sourceMappingURL=Tabs.js.map